import { View, Text, TouchableOpacity } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import Unicon from '@/components/General/Unicon';

const IconPickerInput = ({ title, value, onUpdate, options = [], isNotOnSurface = false, disabled = false }) => {
    return (
        <View style={styles.container}>
            <View style={styles.labelContainer}>
                <Text style={styles.labelText}>{title}</Text>
            </View>
            <View style={styles.grid}>
                {options.map(iconName => {
                    const isSelected = iconName === value;
                    return (
                        <TouchableOpacity
                            key={iconName}
                            testID={`icon-picker-${iconName}`}
                            style={styles.cell(isSelected, isNotOnSurface, disabled)}
                            onPress={() => onUpdate(isSelected ? null : iconName)}
                            activeOpacity={0.7}
                            disabled={disabled}
                            accessibilityState={{ selected: isSelected, disabled }}
                        >
                            <Unicon
                                name={iconName}
                                size={22}
                                colorVariant={isSelected ? "onPrimary" : "textSecondary"}
                            />
                        </TouchableOpacity>
                    );
                })}
            </View>
        </View>
    );
};

const styles = StyleSheet.create(({ colors, fonts, shadows, spacing, roundness }) => ({
    container: {
        marginVertical: spacing.sm,
    },
    labelContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingBottom: 6,
    },
    labelText: {
        color: colors.textSecondary,
        fontFamily: fonts.heading,
        fontSize: 13,
    },
    grid: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 8,
    },
    cell: (isSelected, isNotOnSurface, disabled) => ({
        width: 48,
        height: 48,
        borderRadius: roundness.sm,
        backgroundColor: isSelected ? colors.primary : (isNotOnSurface ? colors.surface : colors.inputBackground),
        boxShadow: isSelected ? shadows.none : (isNotOnSurface ? shadows.card : shadows.none),
        alignItems: 'center',
        justifyContent: 'center',
        outlineStyle: 'none',
        opacity: disabled ? 0.5 : 1,
        _web: {
            cursor: disabled ? 'not-allowed' : 'pointer',
            transition: 'all 0.15s ease',
            _focus: {
                boxShadow: disabled ? 'none' : shadows.input,
            },
            _hover: {
                backgroundColor: disabled
                    ? (isSelected ? colors.primary : (isNotOnSurface ? colors.surface : colors.inputBackground))
                    : (isSelected ? colors.primaryMuted : colors.hover),
            },
        },
    }),
}));

export default IconPickerInput;
